import { render, staticRenderFns } from "./Runload.vue?vue&type=template&id=09c96238&scoped=true"
import script from "./Runload.vue?vue&type=script&lang=js"
export * from "./Runload.vue?vue&type=script&lang=js"
import style0 from "./Runload.vue?vue&type=style&index=0&id=09c96238&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c96238",
  null
  
)

export default component.exports